<template>
  <Layout prop-class="verticalCenter">
    <div class="main-container">
      <div class="nav-wrap">
        
          <div class="back-btn" id="backBtn" @click="backHome">
            <div class="icon">
              <img src="@/assets/image/manager/home.png" alt="">
            </div>
            <div class="label">
              首页
            </div>
          </div>
        
        <div class="nav-item">
          <div class="nav-item-info">
            <div class="val">
              <countTo :startVal='0' :endVal='countData.online' :duration='5000'></countTo>
            </div>
            <div class="label">
              在线人数
            </div>
          </div>
          <div class="nav-item-info">
            <div class="val">
              <countTo :startVal='0' :endVal='countData.history' :duration='5000'></countTo>
            </div>
            <div class="label">
              已学习人数
            </div>
          </div>
          <div class="nav-item-info">
            <div class="val">
              <countTo :startVal='0' :endVal='countData.current' :duration='5000'></countTo>
            </div>
            <div class="label">
              正在学习人数
            </div>
          </div>
          <div class="nav-item-info">
            <div class="val">
              <countTo :startVal='0' :endVal='countData.school' :duration='5000'></countTo>
            </div>
            <div class="label">
              已学习学校
            </div>
          </div>
        </div>
      </div>
      <div class="study-wrap">
        <div class="study-course" id="studyCourse">
          <transition appear appear-to-class="animate__animated animate__bounceInUp ">
            <div class="item-box">
              <div class="item">
                <div class="item-img">
                  <img src="@/assets/image/studyroom/1.png" alt="">
                </div>
                <div class="item-info">
                  <div class="name">
                    RCEP
                  </div>
                  <p title="The Regional Comprehensive Economic Partnership (RCEP) was a 2012 agreement initiated by ASEAN, made by 15 members including China, Jaban. S outh Korea, Australia, New Zealand and ten ASEAN countries. It is the largest and most important free trade agreement negotiation in he Asia-Pacific region. After reaching it, it will cover nearly half of the world's population and nearly a third of the trade volume, becoming the free trade zone with the largest population, the most diversified members and the most dynamic development in the world.">
                    The Regional Comprehensive Economic Partnership (RCEP) was a 2012 agreement initiated by ASEAN, made
                    by 15 members including China, Jaban. S outh Korea, Australia, New Zealand and ten ASEAN countries.
                    It is the largest and most important free trade agreement negotiation in he Asia-Pacific region.
                    After reaching it, it will cover nearly half of the world's population and nearly a third of the
                    trade volume, becoming the free trade zone with the largest population, the most diversified members
                    and the most dynamic development in the world.
                  </p>
                  <div class="btn-wrap" id="firstLearn">
                    <button @click="startEvent('http://hq.gec-star.com/ppt.html')">
                      进入学习
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <transition appear appear-to-class="animate__animated animate__bounceInUp animate__delay-100ms">
            <div class="item-box">
              <div class="item" id="tea">
                <div class="item-img">
                  <img src="@/assets/image/studyroom/2.png" alt="">
                </div>
                <div class="item-info">
                  <div class="name">
                    茶文化
                  </div>
                  <p title="China is the hometown of tea and the birthplace of tea culture. The discovery and utlization of Chinese tea has a history more than4,700 years, and it has been flourishing and spread all over the world. Tea is a national drink of the Chinese nation. It was originated in Shennong, been knwon in Zhou dynasty, flourished in the Tang Dynasty, flourished in the Song Dynasty, and was popularized in the Ming and Qing Dynasties. Chinese tea culture combines Buddhism, Confucianism and Taoism alone, which is a wonderful flower in Chinese culture! At the same time, tea has also become the most popular 、 physical and mental health green drink in the world.">
                    China is the hometown of tea and the birthplace of tea culture. The discovery and utlization of
                    Chinese tea has a history more than4,700 years, and it has been flourishing and spread all over the
                    world. Tea is a national drink of the Chinese nation. It was originated in Shennong, been knwon in
                    Zhou dynasty, flourished in the Tang Dynasty, flourished in the Song Dynasty, and was popularized in
                    the Ming and Qing Dynasties. Chinese tea culture combines Buddhism, Confucianism and Taoism alone,
                    which is a wonderful flower in Chinese culture! At the same time, tea has also become the most
                    popular 、 physical and mental health green drink in the world.
                  </p>
                  <div class="btn-wrap">
                    <button @click="startEvent('http://hq.gec-star.com/tea.html')">
                      进入学习
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <transition appear appear-to-class="animate__animated animate__bounceInUp animate__delay-200ms">
            <div class="item-box">
              <div class="item" id="shopee">
                <div class="item-img">
                  <img src="@/assets/image/studyroom/3.png" alt="">
                </div>
                <div class="item-info">
                  <div class="name">
                    SHOPEE
                  </div>
                  <p>
                    Shopee is an e-commerce platform in Southeast Asia and Taiwan, China. Established and headquartered
                    Singapore in 2015, and subsequently expanded to seven markets in Malaysia, Thailand, Taiwan,
                    Indonesia, Vietnam and the Philippines. Shopee types of goods, including electronic consumer goods,
                    home, beauty care, mother and baby, clothing and fitness equipment.
                  </p>
                  <div class="btn-wrap">
                    <button
                        @click="startEvent('https://view.officeapps.live.com/op/embed.aspx?src=http://hq.gec-star.com/platform2.pptx')">
                      进入学习
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="study-room">
          <img src="@/assets/image/studyroom/bg.png" alt="">
        </div>
      </div>
    </div>
    <el-dialog
        title="学习室"
        top="15px"
        fullscreen
        :visible.sync="dialogVisible"
        width="80%">
    </el-dialog>
    <div class="dialog-wrap" :class="{start:start,inTheAnimation:inTheAnimation}" v-show="start">
      <transition appear appear-to-class="animate__animated animate__bounceInUp">
        <img class="mountains" src="@/assets/image/bg/Mountains.png" alt="" style="z-index: 1000;">
      </transition>
      <transition appear appear-to-class="animate__animated animate__bounceInUp animate__delay-100ms">
        <img class="trees" src="@/assets/image/bg/trees.png" alt="" style="z-index: 999;">
      </transition>
      <transition appear appear-to-class="animate__animated animate__fadeInUp animate__delay-300ms">
        <img class="river" src="@/assets/image/bg/River.png" alt="" style="z-index: 998;">
      </transition>
      <transition appear appear-to-class="animate__animated animate__bounceInUp animate__delay-500ms">
        <img class="sun" src="@/assets/image/bg/Sun.png" alt="" style="z-index: 996;">
      </transition>
      <transition appear appear-to-class="animate__animated animate__backInDown animate__delay-1s">
        <div class="iframe-wrap">
          <iframe :src="pptPath" width="100%" height="786px;" style="border: none;"></iframe>
          <div class="close" @click="close()" id="closeBtn">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </transition>
    </div>
  </Layout>

</template>

<script>
  import countTo from 'vue-count-to'

  export default {
    components: {
      countTo
    },
    data() {
      return {
        show: true,
        dialogVisible: false,
        pptPath: '',
        start: false,
        rcepActive: false,
        teaActive: false,
        shopeeActive: false,
        inTheAnimation: false,
        countData: {},
        DriverInstance: null
      }
    },
    created() {
      this.getCount()
    },
    mounted() {
      this.stepStart()
    },
    methods: {
      backHome(){
        this.$router.push({
          path:'/home',
          query:Object.assign({},this.$route.query)
        })
      },
      stepStart(){
        if(!localStorage.getItem('StudyRoom')){
          this.DriverInstance = this.Driver('StudyRoom')
          setTimeout(() => {
            this.DriverInstance.start()
          }, 1000)
        }
      },
      getCount() {
        this.$axios.get('/student/statistics/get').then(res => {
          if (res.succeed) {
            this.countData = res.statistics
          }
        })
      },
      startEvent(path) {
        this.start = true
        this.pptPath = path
        this.DriverInstance.reset()
        
      },
      close() {
        this.inTheAnimation = true
        setTimeout(() => {
          this.start = false
          this.inTheAnimation = false
        }, 1500)
      }
    }
  }
</script>

<style scoped lang="scss">
  @keyframes bounceOutDownn {
    20% {
      -webkit-transform: translate3d(0, 10px, 0) scaleY(0.985);
      transform: translate3d(0, 10px, 0) scaleY(0.985);
    }
    
    40%,
    45% {
      opacity: 1;
      -webkit-transform: translate3d(0, -20px, 0) scaleY(0.9);
      transform: translate3d(0, -20px, 0) scaleY(0.9);
    }
    
    to {
      opacity: 0;
      -webkit-transform: translate3d(0, 2000px, 0) scaleY(3);
      transform: translate3d(0, 2000px, 0) scaleY(3);
    }
  }
  
  .main-container {
    width: 100%;
    height: 100%;
    max-width: 1600px;
    overflow: hidden;
    
    .nav-wrap {
      width: 100%;
      height: 110px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 12px;
      margin-bottom: 28px;
      display: flex;
      align-items: center;
      padding: 0 45px;
      
      .back-btn {
        cursor: pointer;
        display: flex;
        align-items: center;
        padding-right: 52px;
        position: relative;
        
        &:before {
          content: '';
          width: 2px;
          height: 62px;
          background: #EBEBEB;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        
        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 68px;
          height: 68px;
          background: linear-gradient(140deg, #70A0EB 0%, #005BE7 100%);
          box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
          border-radius: 50%;
          opacity: 1;
          margin-right: 30px;
        }
        
        .label {
          font-size: 22px;
          font-family: Microsoft YaHei UI, sans-serif;
          font-weight: 400;
          line-height: 28px;
          color: #999999;
        }
      }
      
      .nav-item {
        display: flex;
        justify-content: space-around;
        flex: 1;
        padding: 0 100px;
        
        .nav-item-info {
          text-align: center;
          
          .val {
            font-size: 40px;
            font-family: Bahnschrift;
            font-weight: bold;
            line-height: 40px;
            color: #666666;
          }
          
          .label {
            font-size: 18px;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            line-height: 23px;
            color: #999999;
          }
        }
      }
    }
    
    .study-wrap {
      display: flex;
      padding-bottom: 10px;
      
      .study-course {
        margin-right: 48px;
        
        .item-box {
          margin-bottom: 36px;
          width: 1000px;
          height: 210px;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
          border-radius: 12px;
          position: relative;
          
          &:last-child {
            margin-bottom: 0;
          }
        }
        
        .item {
          width: 1000px;
          height: 210px;
          background: #FFFFFF;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
          opacity: 1;
          border-radius: 12px;
          display: flex;
          
          
          &:last-child {
            margin-bottom: 0;
          }
          
          .item-img {
            background: linear-gradient(180deg, rgba(0, 91, 231, 0) 0%, #005BE7 100%);
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
            border-radius: 12px;
          }
          
          .item-info {
            padding: 30px 40px;
            
            .name {
              font-size: 22px;
              font-family: Microsoft YaHei UI, sans-serif;
              font-weight: bold;
              color: #333333;
              margin-bottom: 16px;
            }
            
            p {
              font-size: 14px;
              font-family: Lato-Regular, sans-serif;
              color: #999999;
              word-wrap: break-word;
              line-height: 26px;
              overflow: hidden;
              display: -webkit-box;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              margin-bottom: 16px;
            }
            
            .btn-wrap {
              text-align: right;
              
              button {
                width: 249px;
                height: 45px;
                background: linear-gradient(90deg, #70A0EB 0%, #005BE7 100%);
                box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
                opacity: 1;
                border-radius: 60px;
                color: white;
                font-size: 20px;
                font-family: Microsoft YaHei UI, sans-serif;
              }
            }
            
          }
        }
      }
      
      .study-room {
        background: #FFFFFF;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 12px;
      }
    }
  }
  
  .dialog-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0);
    opacity: 0;
    z-index: -1;
    
    &.start {
      z-index: 9;
      transition: all 1s linear;
      background: url("./../../assets/image/bg/Background.png") 0 0 no-repeat;
      background-size: cover;
      opacity: 0.99;
    }
    
    img {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }
    
    &.inTheAnimation {
      img.sun {
        animation: bounceOutDownn 1s linear 0.1s both;
      }
      
      img.trees {
        animation: bounceOutDownn 1s linear 0.2s both;
      }
      
      img.river {
        animation: bounceOutDownn 1s linear 0.3s both;
      }
      
      img.mountains {
        animation: bounceOutDownn 1s linear 0.4s both;
      }
      
      .iframe-wrap {
        animation: bounceOutDownn 0.1s linear both;
      }
      
      animation: opacityyy 0.5s linear 1s;
      @keyframes opacityyy {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    }
    
    .iframe-wrap {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1111;
      width: 80%;
      height: 786px;
      margin: auto;
      border-radius: 20px;
      overflow: hidden;
      
      .close {
        cursor: pointer;
        width: 40px;
        height: 40px;
        background: white;
        position: absolute;
        right: 10px;
        top: 10px;
        border-radius: 50%;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
      }
    }
  }

</style>
